<template>
    <div v-if="localeBarsArray.length > 0" class = "bar-chart-wrapper align-items-end d-flex gap-1" :style="{'--max-height': maxHeight}">
        <div v-for="(data, i) of localeBarsArray" class="bar" :style="[{'height': `${data.height}%`}, {'background-color': `${data.backgroundColor}`}]">
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            localeBarsArray: [],
            bluebarsArray: [
                {
                    height: 30,
                    backgroundColor: "#D9E4FF",
                },
                {
                    height: 60,
                    backgroundColor: "#D9E4FF",
                },
                {
                    height: 100,
                    backgroundColor: "#1E5EFF",
                },
                {
                    height: 70,
                    backgroundColor: "#D9E4FF",
                },
                {
                    height: 80,
                    backgroundColor: "#D9E4FF",
                },
                {
                    height: 50,
                    backgroundColor: "#D9E4FF",
                }
            ],
            greenbarsArray: [
                {
                    height: 30,
                    backgroundColor: "#C4F8E2",
                },
                {
                    height: 70,
                    backgroundColor: "#C4F8E2",
                },
                {
                    height: 80,
                    backgroundColor: "#C4F8E2",
                },
                {
                    height: 50,
                    backgroundColor: "#C4F8E2",
                },
                {
                    height: 100,
                    backgroundColor: "var(--extra-green)",
                },
                {
                    height: 50,
                    backgroundColor: "#C4F8E2",
                }
            ],
            orangebarsArray: [
                {
                    height: 30,
                    backgroundColor: "#FFF4C9",
                },
                {
                    height: 60,
                    backgroundColor: "#FFF4C9",
                },
                {
                    height: 90,
                    backgroundColor: "#FFF4C9",
                },
                {
                    height: 100,
                    backgroundColor: "#FFC700",
                },
                {
                    height: 50,
                    backgroundColor: "#FFF4C9",
                },
                {
                    height: 70,
                    backgroundColor: "#FFF4C9",
                }
            ],
            redbarsArray: [
                {
                    height: 40,
                    backgroundColor: "#ffaaaa",
                },
                {
                    height: 30,
                    backgroundColor: "#ffaaaa",
                },
                {
                    height: 60,
                    backgroundColor: "#ffaaaa",
                },
                {
                    height: 100,
                    backgroundColor: "#ff0000",
                },
                {
                    height: 90,
                    backgroundColor: "#ffaaaa",
                },
                {
                    height: 50,
                    backgroundColor: "#ffaaaa",
                }
            ],
        }
    },
    props: {
        barsArray: {
            type: Array,
            default: [],
        },
        mode: String,
        maxHeight: {
            type: String,
            default: "55px"
        },
    },
    mounted() {
        this.assignBarArray();
    },
    methods: {
        assignBarArray(){
            if(this.barsArray.length == 0){
                switch (this.mode) {
                    case "blue":
                        this.localeBarsArray = this.bluebarsArray;
                        break;
                    case "green":
                        this.localeBarsArray = this.greenbarsArray;
                        break;
                    case "orange":
                        this.localeBarsArray = this.orangebarsArray;
                        break;
                    case "red":
                        this.localeBarsArray = this.redbarsArray;
                    break; 
                    default:
                        break;
                }
            }else{
                this.localeBarsArray = this.barsArray;
            }
        },
    },
}
</script>
<style scoped>
.bar-chart-wrapper{
    height: 100%;
    max-height: var(--max-height);
}
.bar{
    width: 15px;
    border-radius: 6px;
    background-color: #ffaaaa;
}
</style>